import Terminal from 'react-console-emulator'
import commands from '../components/Commands/commands.js'
import React from 'react'
import getcat from '../utils/cat'

export default function Term() {
    const cmds = commands.commands
    const owrs = commands.overwrites
    const terminal = React.createRef()
    const [prompt, setPrompt] = React.useState('you@mihailcoder:~$ ')
    const [home, sethome] = React.useState('mihailcoder')
    const [dir, setdir] = React.useState({
        'mihailcoder': []
    })

    return (
        <Terminal
            ref={terminal}
            // 👇 ВОТ ЭТА НОВАЯ СТРОЧКА! Она разрешает показывать HTML как картинки
            dangerMode={true}
            welcomeMessage={[
                "Добро пожаловать в терминал MihailCoder!",
                "---",
                "Это сайт-терминал, сделанный на React.",
                "---",
                "Введите 'help', чтобы увидеть список команд.",
                "---",
                "Попробуйте начать с 'cat' (〜￣▽￣)〜",
                "---",
            ]}
            commands={{
                clear: {
                    description: 'Очищает терминал',
                    usage: 'clear',
                    fn: () => {
                        terminal.current.clearStdout()
                    }
                },
                cat: {
                    description: 'Показать случайного милого котика',
                    usage: 'cat',
                    fn: async () => {
                        terminal.current.pushToStdout("(=^･ω･^=) Ищу котика для вас...\n---\n")
                        
                        try {
                            const url = await getcat()
                            // Вставляем картинку как HTML-строку
                            const imgHtml = `<img src="${url}" width="500px" height="380px" alt="cat" style="display: block; margin: 10px 0;" />`
                            terminal.current.pushToStdout(imgHtml)
                        } catch (error) {
                            terminal.current.pushToStdout("Не удалось загрузить котика :(\n---\n")
                        }
                    }
                },
                cd: {
                    description: 'Сменить директорию (понарошку)',
                    usage: 'cd <директория>',
                    fn: (...args) => {
                        if (args.length===1 && args[0]==='..') {
                            if (prompt === 'you@mihailcoder:~$ ') {
                                return 'некуда подниматься'
                            } else {
                                setPrompt(prompt.substring(0, prompt.lastIndexOf('/'))+":~$ ")
                                sethome(prompt.substring(prompt.lastIndexOf('/', prompt.lastIndexOf('/')-1)+1, prompt.lastIndexOf('/')))
                                return 'перешли вверх'
                            }
                        } else {
                            if (dir[home].includes(args[0])) {
                                setPrompt(`${prompt.slice(0, -4)+ "/" + args.join('/') + ":~$ "}`)
                                sethome(args.join('/'))
                                return 'перешли в директорию'
                            } else {
                                return 'директория не найдена'
                            }
                        }
                    }
                },
                ls: {
                    description: 'Показать содержимое текущей директории',
                    usage: 'ls',
                    fn: () => {
                        if (dir[home].length === 0) {
                            return 'здесь пусто :(\nИспользуйте mkdir, чтобы создать директорию.'
                        } else {
                            return dir[home].join('\n')
                        }
                    }
                },
                mkdir: {
                    description: 'Создать директорию',
                    usage: 'mkdir <имя>',
                    fn: (...args) => {
                        if (args.length===1) {
                            setdir({
                                ...dir,
                                [home]: [...dir[home], args[0]],
                                [args[0]]:[]
                            })
                            return `директория ${args[0]} создана.`
                        } else {
                            return 'неверные аргументы'
                        }
                    }
                },
                help: {
                    description: 'Показать все доступные команды',
                    usage: 'help',
                    fn: () => {
                        return `
                            ${Object.keys(owrs).map(cmd => `${cmd}${" ".repeat(12-cmd.length)} | ${owrs[cmd].description}${" ".repeat(39-owrs[cmd].description.length)} | ${owrs[cmd].usage}`).join('\n')}
                            ${Object.keys(cmds).map(cmd => `${cmd}${" ".repeat(12-cmd.length)} | ${cmds[cmd].description}${" ".repeat(39-cmds[cmd].description.length)} | ${cmds[cmd].usage}`).join('\n')}
                        `
                    }
                },
                ...cmds
            }}
            promptLabel={prompt} 
            autoFocus
            style={{
                backgroundColor:null,
                minHeight: null,
                maxHeight: null,
                overflow: 'auto',
                height: '100%',
                width: '100%',     
            }}
            styleEchoBack='fullInherit'
            contentStyle={{ color: '#ffb86c' , fontWeight: 'normal', paddingLeft: null}}
            promptLabelStyle={{ color: '#ff5555' , fontWeight:'normal'}}
            inputTextStyle={{ color: '#f1fa8c' , fontWeight: 'normal'}}
            messageStyle={{ color: '#8be9fd' , fontWeight: 'normal', paddingLeft: null}}
            scrollBehavior='auto'
            noDefaults
        />
    )
}